export const DEFAULT_OPTIONS = {
  unit: 15, // minutes
  step: 58, // pixels
  offset: 16, // pixels
};
